// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1npqX","label":"SetPasswdForm_label__1gG7B"};